module.exports = __webpack_public_path__ + "static/media/02.0bd62196.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/presentare/02.jpg
// module id = 581
// module chunks = 0